const playerBreadcrumb = (data) => {
  const { teamName } = data || {}

  return [teamName ? teamName.toUpperCase() : '', 'PLAYER MANAGEMENT']
}

export default playerBreadcrumb
